const HIGHLIGHT_CLASS = "cm-line-highlight";
const HIGHLIGHT_MS = 2500;
const MAX_SCROLL_ATTEMPTS = 30;

export function highlightFeedLine(container, lineNumber, { instant = true } = {}) {
  if (!container || !lineNumber) {
    return false;
  }

  const target = container.querySelector(`[data-feed-line="${lineNumber}"]`);
  if (!target) {
    return false;
  }

  target.scrollIntoView({ block: "center", behavior: instant ? "auto" : "smooth" });
  target.classList.add(HIGHLIGHT_CLASS);
  window.setTimeout(() => {
    target.classList.remove(HIGHLIGHT_CLASS);
  }, HIGHLIGHT_MS);
  return true;
}

export function highlightFeedLineWhenReady(container, lineNumber, onComplete) {
  if (!container || !lineNumber) {
    return () => {};
  }

  let attempts = 0;
  let cancelled = false;
  let rafId = 0;

  const tryHighlight = () => {
    if (cancelled) {
      return;
    }
    const found = highlightFeedLine(container, lineNumber, { instant: true });
    if (found) {
      onComplete?.();
      return;
    }
    attempts += 1;
    if (attempts < MAX_SCROLL_ATTEMPTS) {
      rafId = window.requestAnimationFrame(tryHighlight);
    }
  };

  rafId = window.requestAnimationFrame(tryHighlight);

  return () => {
    cancelled = true;
    if (rafId) {
      window.cancelAnimationFrame(rafId);
    }
  };
}
